import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _nth from 'lodash/nth';
import _slice from 'lodash/slice';
import { tget } from '@tekion/tekion-base/utils/general';
export var isLastRow = function isLastRow(value, index) {
  return tget(value, [index, 'isLastRow'], false);
};
export var updateDestinationIndex = function updateDestinationIndex(_ref) {
  var value = _ref.value,
    destinationIndex = _ref.destinationIndex,
    isFirstRowDefault = _ref.isFirstRowDefault;
  if (isLastRow(value, destinationIndex)) return destinationIndex - 1;
  if (isFirstRowDefault && destinationIndex === 0) return 1;
  return destinationIndex;
};
export var isDragDropValid = function isDragDropValid(_ref2) {
  var value = _ref2.value,
    sourceIndex = _ref2.sourceIndex,
    destinationIndex = _ref2.destinationIndex,
    isFirstRowDefault = _ref2.isFirstRowDefault,
    dragNotAllowed = _ref2.dragNotAllowed;
  if (destinationIndex === sourceIndex) return false;
  if (isFirstRowDefault && sourceIndex === 0) return false;
  if (isLastRow(value, sourceIndex)) return false;
  return !dragNotAllowed;
};
export var rearrangeRowData = function rearrangeRowData(_ref3) {
  var value = _ref3.value,
    sourceIndex = _ref3.sourceIndex,
    destinationIndex = _ref3.destinationIndex;
  var sourceValue = _nth(value, sourceIndex);
  var withoutSource = [].concat(_toConsumableArray(_slice(value, 0, sourceIndex)), _toConsumableArray(_slice(value, sourceIndex + 1)));
  var beforeDestination = _slice(withoutSource, 0, destinationIndex);
  var afterDestination = _slice(withoutSource, destinationIndex);
  return [].concat(_toConsumableArray(beforeDestination), [sourceValue], _toConsumableArray(afterDestination));
};